// Release Quarter Badge - PD Europe
(function() {

  // === Product Detail Page Badge ===
  function injectProductPageBadge() {
    var rq = window.general && window.general.release_quarter;
    if (!rq || rq === '') return;
    var priceEl = document.querySelector('.f8pr-price');
    if (!priceEl) return;
    if (priceEl.previousElementSibling && priceEl.previousElementSibling.classList.contains('rq-badge-wrap')) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'rq-badge-wrap';
    wrapper.style.cssText = 'margin-bottom:8px;';
    var badge = document.createElement('span');
    badge.style.cssText = 'display:inline-block;background-color:#005bd3;color:#fff;padding:5px 14px;border-radius:4px;font-size:14px;font-weight:700;';
    badge.textContent = 'Estimated Release Date: ' + rq;
    wrapper.appendChild(badge);
    priceEl.parentNode.insertBefore(wrapper, priceEl);
  }

  // === Collection Page Badges ===
  function injectCollectionBadges() {
    var rqMap = window.general && window.general.products_rq;
    if (!rqMap) return;
    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function(card) {
      if (card.hasAttribute('data-product-id')) return;
      if (card.querySelector('.rq-badge-collection')) return;
      var btn = card.querySelector('.wishlist-productcard');
      if (!btn) return;
      var productId = btn.getAttribute('data-product-id');
      if (!productId) return;
      var rq = rqMap[productId];
      if (!rq || rq === '') return;
      var h3 = card.querySelector('h3');
      if (!h3) return;
      // Insert inside h3, before the title <a>, so it appears between vendor and title
      var titleLink = h3.querySelector('a');
      var badge = document.createElement('span');
      badge.className = 'rq-badge-collection';
      badge.style.cssText = 'display:block;margin:3px 0;';
      var inner = document.createElement('span');
      inner.style.cssText = 'display:inline-block;background-color:#005bd3;color:#fff;padding:3px 10px;border-radius:4px;font-size:12px;font-weight:700;';
      inner.textContent = 'Estimated Release Date: ' + rq;
      badge.appendChild(inner);
      if (titleLink) {
        h3.insertBefore(badge, titleLink);
      } else {
        h3.appendChild(badge);
      }
    });
  }

  function init() {
    injectProductPageBadge();
    injectCollectionBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
